import { Object3D } from 'three';
import { Raycaster } from 'three';
import { Vector2 } from 'three';

import { Sections } from '../views/Sections';

import { Time } from 'ohzi-core';
import { Input } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';

import { ViewManager } from 'ohzi-core'

export default class StationaryState{

	constructor(camera_controller, state_handler) {
		this.camera_controller = camera_controller;
		this.state_handler = state_handler;

		this.raycaster = new Raycaster();
    	this.mouse = new Vector2();

		this.home_view = ViewManager.get_view_by_name(Sections.HOME)


	}

	set_up(sub_scene_handler) {
		if (sub_scene_handler.icon && !sub_scene_handler.icon.no_label) {
			this.home_view.show();
			this.home_view.hide_back_button();

		} else {
			if(sub_scene_handler.parent_scene) {
				this.home_view.show_back_button(
				(()=> {
					this.go_to(sub_scene_handler.parent_scene);
				}).bind(this)
				)
			} else {
				this.home_view.hide_back_button();
			}
		}

		this.sub_scene_handler = sub_scene_handler;
		this.raycasteable_items = sub_scene_handler.get_raycasteables();

		this.home_view.set_callback(
			(()=> {
				if(this.sub_scene_handler.parent_scene)
				this.go_to(this.sub_scene_handler.parent_scene);
			}).bind(this)
		);
	}

	go_to(other_sub_scene_handler) {
		this.state_handler.go_to_fly(other_sub_scene_handler);
	};

	fade_out () {

	};

	fade_in () {

	};

	animate() {

	};

	update() {
		this.sub_scene_handler.update()

		let click = false;

		//if(Time.elapsed_time % 5 < 0.1) {
		//	console.log("position : " ,CameraManager.current.position)
		//	console.log("target : " ,this.camera_controller.reference_position)
		//	console.log("tilt : " ,this.camera_controller.current_tilt)
		//	console.log("orientation : " ,this.camera_controller.current_orientation)
		//}

		if (Input.right_mouse_button_pressed && this.sub_scene_handler.parent_scene) {
			this.go_to(this.sub_scene_handler.parent_scene);
			return;
		}

		if(Input.left_mouse_button_pressed)
  			this.button_pressed_time = Time.elapsed_time

		if(Input.left_mouse_button_released)
		{
		  	let pressed_time = Time.elapsed_time - this.button_pressed_time

			if(pressed_time < 0.2)
				click = true;
		}

		//this.sub_scene_handler.sub_scenes.forEach((element)=>{
		//	element.highlight(false);
		//})

		// update the picking ray with the camera and mouse position
    	this.mouse.set(Input.NDC.x, Input.NDC.y);
    	this.raycaster.setFromCamera( this.mouse, CameraManager.current );
    	// calculate objects intersecting the picking ray
    	const intersects = this.raycaster.intersectObjects( this.raycasteable_items, true );
    	if (intersects.length > 0) {

    	  //intersects[ 0 ].object.owner.highlight(true, Input.left_mouse_button_released, this.camera_controller);
    	  if(click) {
    	  	this.go_to(intersects[ 0 ].object.owner);
    	  }
    	}



	};
}